// Files Data Base — the browser-side resize that replaced Supabase Image Transformation.
// The server-side resize is billed per image ($5 per 1,000 beyond the plan) and is forbidden in
// this project (CLAUDE.md "Performance Rules"; the 2026-10-27 guard test keeps it out). A
// thumbnail is the ordinary original, downloaded through the plain authenticated object route,
// then shrunk here with a canvas. Pure maths in fitBox (tested); the canvas part needs a browser.

/** The size a photo takes inside a box — contain (never cropped) and never enlarged. */
export function fitBox(srcW, srcH, boxW, boxH) {
  if (!(srcW > 0) || !(srcH > 0) || !(boxW > 0) || !(boxH > 0)) return { w: 0, h: 0 };
  const k = Math.min(1, boxW / srcW, boxH / srcH);
  return { w: Math.max(1, Math.round(srcW * k)), h: Math.max(1, Math.round(srcH * k)) };
}

const QUALITY = 0.75;

/**
 * Shrink an image Blob to fit `size` ({w,h}). Returns a new JPEG Blob, or the original Blob when
 * it already fits. Throws when the browser cannot decode it (the caller treats that as "no thumbnail").
 */
export async function resizeBlob(blob, size) {
  const bmp = await createImageBitmap(blob);
  try {
    const { w, h } = fitBox(bmp.width, bmp.height, size.w, size.h);
    if (!w || (w === bmp.width && h === bmp.height)) return blob;
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';            // product photos sit on white; a transparent PNG must not turn black
    ctx.fillRect(0, 0, w, h);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(bmp, 0, 0, w, h);
    const out = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    return out || blob;
  } finally {
    if (bmp.close) bmp.close();
  }
}
